import { PageHero } from "@/components/site/Bits";
import { Reveal } from "@/components/site/Reveal";
import { Target, Handshake, Boxes } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export default function About() {
  const { t } = useI18n();
  const story = t("about.story");
  const cards = [
    { icon: Target, k: "goal" }, { icon: Handshake, k: "acc" }, { icon: Boxes, k: "print" },
  ];
  return (
    <div>
      <PageHero eyebrow={t("about.eyebrow")} title={t("about.title")} subtitle={t("about.subtitle")} />
      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-16 space-y-6">
        {(Array.isArray(story) ? story : []).map((p, i) => (
          <Reveal key={i} delay={i * 0.04}><p className="text-lg text-zinc-300 leading-relaxed">{p}</p></Reveal>
        ))}
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24">
        <div className="grid md:grid-cols-3 gap-5">
          {cards.map((x, i) => (
            <Reveal key={x.k} delay={i * 0.08}>
              <div className="glass rounded-3xl p-8 card-hover h-full">
                <span className="w-12 h-12 rounded-xl bg-brand-gradient flex items-center justify-center"><x.icon className="w-6 h-6 text-white" /></span>
                <h3 className="mt-5 font-display font-semibold text-xl text-white">{t(`about.${x.k}_t`)}</h3>
                <p className="mt-2 text-zinc-400">{t(`about.${x.k}_d`)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
